<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">

						<div class="element-wrapper">

							<h6 class="element-header" v-b-toggle.filter variant="primary">
								{{ t.navigation.competition_trends }}
							</h6>
							<div class="element-box-tp">
								<table-component

										v-if="status == 200"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="data"
										sort-by="played"
										sort-order="desc"
								>

									<table-column :label="t.navigation.sports" cell-class="w150">
										<template slot-scope="row">
											<span> {{ row.sportName }}</span>
										</template>
									</table-column>

									<table-column :label="t.navigation.competitions" cell-class="w250">
										<template slot-scope="row">
											<span> {{ row.name }}</span>
										</template>
									</table-column>

									<table-column :label="t.betting.cancelled" show="cancelled" cell-class="w50 text-right">
									</table-column>

									<table-column :label="t.betting.win" show="win" cell-class="w50 text-right">
									</table-column>

									<table-column :label="t.betting.loss" show="loss" cell-class="w50 text-right">
									</table-column>

									<table-column :label="t.betting.waiting" show="waiting" cell-class="w50 text-right">
									</table-column>

									<table-column :label="t.total" show="waiting" cell-class="w50 text-right">
										<template slot-scope="row">
											{{ (row.waiting + row.loss + row.win + row.cancelled) }}
										</template>
									</table-column>

									<table-column label="%" cell-class="w50 text-right">
										<template slot-scope="row">
											<router-link :to="{name: 'bet_trends', query: {competition: row.id, period: selectedPeriod}}">{{ (row.waiting + row.loss + row.win + row.cancelled) | percentage(totalPlayed) }}%</router-link>
										</template>
									</table-column>

								</table-component>
							</div>
						</div>

					</div>
				</div>
			</div>

			<!--------------------
				START - Sidebar
				-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel">
					<i class="ti-shift-right"></i>
				</div>
				<div class="element-wrapper">

					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">

						<form class="justify-content-sm-end">
							<select class="form-control form-control-sm form-control-faded" v-model="selectedPeriod">
								<option v-for="option in accountingPeriods" v-bind:value="option.value">
									{{ t.filter.accounting[option.value] }}
								</option>
							</select>
						</form>

						<div class="box-list mt-3">
							<ul class="vibe-list">
								<li class="b-b" :class="(s.id == sport) ? 'active' : ''" v-for="s in sports">
									<a href="javascript:;" v-on:click="sport = s.id">{{ s.nameLn }}</a>
								</li>
							</ul>
						</div>

					</div>
				</div>
			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>


	</div>
</template>

<script>
    import formatter from '@/mixins/formatter'
    import { TableComponent, TableColumn } from 'vue-table-component'

    export default {
        name: 'competitionTrends',
        components: { 'table-component': TableComponent, 'table-column': TableColumn},
        mixins: [formatter],
        data () {
            return {
                isLoading: false,
                t: this.$root.t,
                data: '',
                status: 0,
                w: window.innerWidth,
                totalPlayed: 0,
                selectedPeriod: 'today',
                accountingPeriods: [
                    { label: 'Today', value: 'today' },
                    { label: 'Yesterday', value: 'yesterday' },
                    { label: 'This Week', value: 'this_week' },
                    { label: 'This Month', value: 'this_month' },
                    { label: 'Q1', value: 'q1' },
                    { label: 'Q2', value: 'q2' },
                    { label: 'Q3', value: 'q3' },
                    { label: 'Q4', value: 'q4' },
                    { label: 'Financial First Half', value: 'first_financial_half' },
                    { label: 'Financial Second Half', value: 'second_financial_half' },
                ],
                sports: null,
                sport: 1
            }
        },
        watch: {
            '$route.query.market' () {
                this.$refs.playedBets.open()
            },
            'selectedPeriod' (o, n) {
                this.fetchReport()
                this.$router.push({query: {period: o}});
            },
            'sport' (v) {
                this.fetchReport()
                this.$router.push({query: {period: this.selectedPeriod, sport: v}});
            }
        },
        mounted () {

            setTimeout( () => {
                this.selectedPeriod = (this.$route.query.period) ? this.$route.query.period : this.selectedPeriod;
            this.sport = (this.$route.query.sport) ? this.$route.query.sport : this.sport;
        },500);

            this.fetchSports()
            this.fetchReport()
        },
        methods: {
            closeModal () {
                this.$router.push({ query: { market: 99999 } });
                setTimeout( () => {
                    window.document.body.style.overflow = 'auto';
            }, 500);
            },
            fetchReport () {
                this.isLoading = true;
                this.$http.get(api+'api/v1/analytics/bet/competitons', {params: { period: this.selectedPeriod, sport: this.sport }}).then(response => {
                    // get body data
                this.data = response.body.result;
                this.totalPlayed = response.body.totalPlayed;
                this.isLoading = false;
                this.status = response.status;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            },
            fetchSports () {
                this.$http.get(api+'api/v1/fixture/sport?per_page=100').then(response => {
                    // get body data
                    this.sports = response.body.result.sport;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/competitionTrends.vue